import { useState } from 'react';
import './disclaimer-popup.css';

const DisclaimerPopup = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="modal-overlay" role="presentation">
      <div
        className="modal-content"
        role="dialog"
        aria-modal="true"
        aria-labelledby="disclaimer-title"
      >
        <h2 className="modal-title" id="disclaimer-title">
          Disclaimer
        </h2>
        <p className="modal-text">
          The insights and information provided on this platform are generated
          using AI models and data analytics. While we strive for accuracy, AI
          models are not infallible and may produce errors. We encourage users
          to verify information independently and consult additional sources
          when making decisions. By continuing to use this platform, you
          acknowledge these limitations.
        </p>
        <button
          type="button"
          onClick={() => setIsVisible(false)}
          className="modal-button"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default DisclaimerPopup;
